export default "__VITE_ASSET__3a703920__"